export enum LocalStorageEnum {
  ACCESS_TOKEN = 'access_token',
  FILE_ACCESS_TOKEN = 'file_access_token',
}
